import { useReducer } from 'react';

type onBackClickCallable = (() => void) | null;
interface InterfaceStoreData {
  menuDrawerOpen?: boolean;

  onBackClick?: onBackClickCallable;
}

export interface InterfaceStoreType extends InterfaceStoreData {
  toggleMenuDrawer: (state?: boolean) => void;

  setOnBackClick: (callback: onBackClickCallable) => void;
}

export default function useInterfaceStore(): InterfaceStoreType {
  const [store, setStore] = useReducer(
    (prev: InterfaceStoreData, newState: Partial<InterfaceStoreData>) => ({
      ...prev,
      ...newState
    }),
    {
      menuDrawerOpen: false
    }
  );

  const toggleMenuDrawer = (state?: boolean) => {
    setStore({
      menuDrawerOpen: state !== undefined ? state : !store.menuDrawerOpen
    });
  };

  const setOnBackClick = (callback?: onBackClickCallable) => {
    setStore({ onBackClick: callback });
  };

  return {
    menuDrawerOpen: store.menuDrawerOpen,
    toggleMenuDrawer,
    onBackClick: store.onBackClick,
    setOnBackClick
  };
}
